import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

import { Observable, of as observableOf } from 'rxjs';
import { first, map } from 'rxjs/operators';

import { DialogService } from '../../dialogs/dialogs.service';
import { ProtectedControlsDialogComponent } from '../../dialogs/protected-controls-dialog/protected-controls-dialog.component';
import { ProtectedControlsService } from './protected-controls.service';

@Injectable({ providedIn: 'root' })
export class ProtectedControlsGuardService implements CanDeactivate<any> {
  constructor(
    private protectedControls: ProtectedControlsService,
    private dialogService: DialogService,
  ) {}

  public canDeactivate(): Observable<boolean> {
    if (
      this.protectedControls.locked &&
      !this.protectedControls.reports.every(
        report => report.name === '<p><br /></p>' && report.newValue === '<p><br /></p>',
      )
    ) {
      return this.dialogService
        .openCustom(ProtectedControlsDialogComponent, {}, {})
        .afterClosed.pipe(
          map(result => !!result),
          first(),
        );
    } else {
      return observableOf(true);
    }
  }
}
